module.exports = __webpack_public_path__ + "static/media/201IT154.bb9e9bd9.jpg";